import { Link } from "react-router-dom";
import contact from "@config/contact.json";

export default function Footer({ branding, t }) {
  return (
   <footer className="mt-20 border-t-4 border-[#D4AF37] bg-gradient-to-r from-[#6A1515] via-[#1F4698] to-[#D65A2D] text-white">
      <div className="section-shell grid gap-10 py-12 md:grid-cols-[1.2fr_0.8fr_0.8fr]">

        {/* Company Information */}
        <div>
          <img
            src={branding.logo.primary}
            alt={branding.logo.alt}
            className="mb-5 h-14 rounded-xl bg-white p-2 shadow-md"
          />

          <p className="max-w-xl text-sm leading-6 text-white/90">
            {branding.shortDescription}
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h2 className="mb-4 text-sm font-black uppercase tracking-[0.18em] text-[#D4AF37]">
            Explore
          </h2>

          <div className="grid gap-2 text-sm text-white/90">
            {t.nav.slice(1, 7).map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="transition duration-200 hover:text-[#D4AF37]"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Contact Information */}
        <div>
          <h2 className="mb-4 text-sm font-black uppercase tracking-[0.18em] text-[#D4AF37]">
            Contact
          </h2>

          <div className="grid gap-2 text-sm text-white/90">
            <span>{contact.address}</span>

            <a
              href={`tel:${contact.phone}`}
              className="transition duration-200 hover:text-[#D4AF37]"
            >
              {contact.phone}
            </a>

            <a
              href={`mailto:${contact.email}`}
              className="transition duration-200 hover:text-[#D4AF37]"
            >
              {contact.email}
            </a>

            <span>{contact.officeHours}</span>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="border-t border-white/20 py-5 text-center">
        <p className="text-xs text-white/80">
          © Copyright 2026 {branding.legalName}. All Rights Reserved.
        </p>

        <p className="mt-2 text-xs text-white/70">
          Designed & Developed with ❤️ by{" "}
          <span className="font-semibold text-[#D4AF37]">
            Anup Meshram
          </span>
        </p>
      </div>
    </footer>
  );
}